var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("navbar-header"),
      _vm._v(" "),
      _c(
        "b-container",
        { staticClass: "mt-3" },
        [
          _c(
            "b-tabs",
            { attrs: { "content-class": "mt-3" } },
            [
              _c(
                "b-tab",
                { attrs: { title: "Статистика по заказам", active: "" } },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("date-filter", {
                            attrs: { namespace: _vm.namespace }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "mt-3" },
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "6" } },
                        [
                          _c("rest-point-filter", {
                            attrs: { namespace: _vm.namespace }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { md: "6" } },
                        [
                          _c("delivery-type-filter", {
                            attrs: { namespace: _vm.namespace }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("h4", { staticClass: "mt-3" }, [
                    _vm._v("Совокупная статистика")
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "stats-blocks mt-3" },
                    _vm._l(_vm.statsStages, function(statStage) {
                      return _c(
                        "b-col",
                        {
                          key: statStage.title,
                          staticClass: "stats-col",
                          attrs: { md: "3" }
                        },
                        [
                          _c("stats-order-block", {
                            staticClass: "stats-item",
                            attrs: { stats: statStage }
                          })
                        ],
                        1
                      )
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "mt-4" },
                    [
                      _c(
                        "b-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("table-detailed-stats-workshop", {
                            attrs: {
                              vuexNamespace: _vm.namespace,
                              stats: _vm.statsWorkshopsCooked
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                { attrs: { title: "Выполнение заказов" } },
                [_c("stats-order-completion")],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                { attrs: { title: "Статистика по сотрудникам кол-центра" } },
                [_c("AdminWorkerStats")],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                { attrs: { title: "Мотивация поваров" } },
                [_c("motivate-cook-stats")],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-59da9f18", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59da9f18","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/StatsAdminLayout.vue
// module id = null
// module chunks = 